import { render } from "./Milestone.vue?vue&type=template&id=62dd4e11&scoped=true"
import script from "./Milestone.vue?vue&type=script&lang=js"
export * from "./Milestone.vue?vue&type=script&lang=js"

import "./Milestone.vue?vue&type=style&index=0&id=62dd4e11&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62dd4e11"]])

export default __exports__